import React, {useState} from 'react';
import {Button, Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import CustomNavbar from "../../../components/CustomNavbar";
//import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import SidebarEvaluacionDesempenio from '../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio';
import comp from '../../../images/competencias.png';
const Admin = () => {
  const [show, setShow] = useState(true)
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return <>
    <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
    <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
    <div className="custom-wrapper">
      <Container fluid>
        <div className="jumbotron ft-banner">
          <main>
            <h1>Evaluacion del Desempeño</h1>
            <p className='mb-4 text-muted'>El módulo de evaluación del desempeño tiene por objetivo la visualización de automatizar el proceso de evaluación de los colaboradores </p>
           {/*<Link 
              to='/seleccion-contratacion/administracion/motivos-plazas-vacantes'
              className="btn btn-primary rounded-pill">Agregar motivo de plaza vacante</Link>*/} 
          </main>
          <div className="figure">
            <img src={comp} alt="descriptores y perfiles" />
          </div>
        </div>
      </Container>
    </div>
  </>
}




export default Admin